<div *ngIf="!isLoading" class="modal-body cart-modal-body">
  <div *ngFor="let cartItem of cartInfo.ItemSummary; let i = index;">
    <div *ngIf="cartItem.Name != 'CINEQUEST DONATION'">
      <div style="background: #DE1B36 !important;">
        <p style="display: grid; text-align: center; padding-top: 7px;"><b>{{cartItem.Name}}</b> |
          {{cartItem.venueName}} | {{cartItem.dates}} |</p>
      </div>
      <div style="overflow: auto;">
        <table style="color: white;" class="table table-condensed">
          <thead>
            <tr>
              <th>Type</th>
              <th>Tier</th>
              <th>Price</th>
              <th>Fee</th>
              <th>Event Type</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{cartItem.type}}</td>
              <td>{{cartItem.TierName}}</td>
              <td>{{cartItem.Price | currency}}</td>
              <td>{{cartItem.Fee | currency}}</td>
              <td>{{cartItem.ShortDescriptive1}}</td>
              <td>
                <p class="underline-on-hover" style="text-align: center; cursor: pointer;" (click)="deleteTicket(i)"><a>Remove Ticket</a></p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div *ngIf="cartItem.Name == 'CINEQUEST DONATION'">
      <div class="row" style="background: #DE1B36 !important;">
        <p class="col-lg-6 col-md-6" style="display: grid; text-align: center; padding-top: 7px;">
          <b>{{cartItem.Name}}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;{{cartItem.Prices[0].Amount | currency}}</b></p>
        <p class="col-lg-6 col-md-6 underline-on-hover" style="text-align: center; padding-top: 7px; cursor: pointer;" (click)="deleteTicket(i)"><a
            href="">Remove Donation</a></p>
      </div>
    </div>
  </div>
  <p>Purchases: {{cartInfo.Subtotal | currency}}</p>
  <p>Total: {{cartInfo.OrderTotal | currency}}</p>
</div>
<div *ngIf="!isLoading" class="modal-footer">
  <button type="button" class="btn btn-primary" (click) = "checkOutMethod()"
    style="background: #DE1B36 !important; border: 1px red solid; cursor: pointer; color: white; margin-bottom: 10px;">Checkout</button>
  <button type="button" class="btn btn-primary pull-right" (click)="closeModal()" data-dismiss="modal"
    style="background: #DE1B36 !important; border: 1px red solid; cursor: pointer; color: white; margin-bottom: 10px;">Continue
    Shopping</button>
</div>
<app-loading-spinner *ngIf="isLoading"></app-loading-spinner>
